export default "/_next/static/images/co-development-bg@2x-6d0ece3b78c70071e2ea639473b4786c.png";